export default __webpack_public_path__ + "fonts/iconfont.ca414273986828ae24f36427ac3ee6c8.ttf";